<template>
<div class="page_order page">
    <!-- <van-tabs v-model="active" swipe-threshold="5" @click="onTabsClick">
		<van-tab title="全部" :name="0"></van-tab>
		<van-tab title="审核中" :name="1"></van-tab>
        <van-tab title="招标中" :name="2"></van-tab>
		<van-tab title="已完成" :name="3"></van-tab>
    </van-tabs> -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
		<!-- 审核中 招标中 -->
		<van-list v-model="loading_dingzhi" :finished="finished_dingzhi" finished-text="没有更多了" @load="getDingZhiData">
            <div class="list" >
                <div class="item" v-for="(order,index) in dingzhiList" :key="index" >
                    <!-- <div class="item_t" @click="goDingzhiDetail(order)">
                        <div class="item_t_t">
                            <img :src="order.thumb ? order.thumb : $publicData.defaultTouxiang" alt="" class="thumb">
                            <div class="title">{{ order.username }}</div>
                        </div>
                        <div class="status">{{ order.orderStatus }}</div>
                    </div> -->
                    <!-- 商品信息 -->
                    <div class="item_nr" @click="goDingzhiDetail(order)">
                        <div class="item_nr_l">
							<van-image :src="order.image ? imageUrl+order.image : $publicData.intangibleDefault" class="tu" fit="cover"/>
                        </div>
                        <div class="item_nr_r dingzhi">
                            <div class="info">
                                <div class="title slh_s">{{ order.title }}</div>
                                <div class="desc slh">{{ order.content }}</div>
                            </div>
                            <div class="jiage">预估价格: <span class="price">¥{{ order.price }}</span></div>
                        </div>
                    </div>
                    <div class="item_b" >
                        <div class="actions">
                            <div class="action" @click="editDingzhi(order)">编辑价格</div>
                        </div>
                    </div>
                </div>
            </div>
        </van-list>
    </van-pull-refresh>
    <van-dialog v-model="showEditPrice" show-cancel-button @beforeClose="beforeClose" @confirm="confirm" @cancle="showEditPrice = false" title="设置成交金额" >
        <van-cell-group class="editInfo">
            <van-cell center title="是否可购买">
                <template #right-icon>
                    <van-switch v-model="is_buy" size="24" />
                </template>
            </van-cell>
            <van-cell center title="是否分销">
                <template #right-icon>
                    <van-switch v-model="is_fx" size="24" />
                </template>
            </van-cell>
            <van-field
                v-if="is_fx"
                v-model="agent_fx"
                label="分销比例"
                placeholder="分销比例"
            />
            <van-field 
                v-model="dingzhi_price" 
                label="成交价格" 
                placeholder="请输入成交价格" 
            />
        </van-cell-group>
    </van-dialog>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    // name: "my-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            page:1,
            size:10,
            finished: false,
            loading: false,
			refreshing: false,
			active: 0, // 默认全部
			loading_dingzhi: false,
			finished_dingzhi: false,
            dingzhiList: [], // 审核或招标列表
            showEditPrice: false,
            is_buy: true,
            is_fx: true,
            dingzhi_price: '',
            agent_fx: '',
            selectOrder: null,
            token: null
        };
    },
    created: function () {
		// console.log('this.active',this.active,typeof(this.active))
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '我的定制'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.onRefresh()
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            this.onRefresh()
        }
	},
	mounted: function(){
		
	},
    methods: {
        onTabsClick(name, title) {
            this.active = name
            this.onRefresh()
        },
        onRefresh() {
			// 清空列表数据
			this.finished_dingzhi = false;
			// 重新加载数据
			// 将 loading 设置为 true，表示处于加载状态
			this.loading_dingzhi = true;
			this.page = 1
			this.getDingZhiData()
            
        },
		// 待审核或招标中列表
		getDingZhiData(){
			if (this.token == null || this.token == undefined || this.token == '') {
                return
            }
            // var token = this.$store.getters.token;
            var params = {
                token: this.token,
                page: this.page,
				size: this.size,
			}
			this.$api.dingzhi.traCorList(params).then(res=>{
				if(res.code == 200){
                    // this.orderList = res.result
                    var list = res.result
                    var old = this.dingzhiList
                    if (this.page == 1) {
                        old = []
                    } 
                    for (let i = 0; i < list.length; i++) {
                        var order = list[i].customizedcommunity
                        var album = order.album
                        var images = album.split(",");
						if (images.length > 0) {
                            order.image = images[0]
						}
						if(order.status == 0){
							// 正常状态
							if(order.work_status == 1){
								order.orderStatus = '已完成'
							}else if(order.work_status == 0){
								if(order.review_status == 1){
									order.orderStatus = '招标中'
								}else if(order.review_status == 0){
									order.orderStatus = '审核中'
								}
							}
						}else if(order.status == 1){
							// 取消状态
							order.orderStatus = '已取消'
						}
                        old.push(order)
                    }
                    this.dingzhiList = old
                    if (list.length < this.size) {
                        // 数据全部加载完
                        this.finished_dingzhi = true
                        this.refreshing = false
                        return;
                    }
				} else {
					this.finished_dingzhi = true
                    this.$toast(res.message)
                }
                this.page++;
                this.refreshing = false
                this.loading_dingzhi = false;
			})
		},
		// 编辑定制
		editDingzhi(order){
            console.log(order)
            this.is_buy = true
            this.is_fx = true
            this.dingzhi_price = ''
            this.agent_fx = ''
            this.selectOrder = order            
            this.showEditPrice = true
        },
        beforeClose(action, done) {
            if (action === 'confirm') {
                if (this.dingzhi_price || this.dingzhi_price == undefined || this.dingzhi_price == '') {
                    this.$toast('请输入成交价格1')
                    this.showEditPrice = true
                    done(false);
                    return
                }
            } else {
                done();
            }
        },
        confirm() {
            console.log(this.dingzhi_price)
            if (this.dingzhi_price == null || this.dingzhi_price == undefined || this.dingzhi_price == '') {
                this.$toast('请输入成交价格')
                return
            }
            var params = {
                token: this.token,
                id:this.selectOrder.id,
                price: this.dingzhi_price,
                is_buy: this.is_buy?'1':'0',
                is_fx: this.is_fx?'1':'0',
                agent_fx: this.agent_fx
            }
            this.$api.tradesman.updateDingzhi(params).then(res => {
                if (res.code == 200) {
                    this.onRefresh()
                    this.$toast('修改成功')
                } else {
                    this.$toast(res.message)
                }
            })
        },
		// 报名情况
		toSignUp(order){
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/order/dingzhi/bid?id=' + order.id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/order/dingzhi/bid',
                    query: {
                        id: order.id
                    }
                })
            }
		},
		// 查看定制详情
		goDingzhiDetail(item){
			if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/dingzhi/detail/user?id=' + item.id + '&from_user=1'
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/dingzhi/detail/user',
                    query: {
						id: item.id,
						from_user: 1
					}
                })
            }
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
